<template>
	<div class="home">
		<Header />
		<div class="theme">
			<div class="wrapper">
				<div class="con">
					<p class="title" v-html="$t('theme.title')"></p>
					<p class="sub-title" v-html="$t('theme.desc')"></p>
					<div class="button-area">
						<div class="btn" @click="btnClick('join')">{{$t('btn_trade')}}</div>
						<div class="btn sec" @click="btnClick('about')">{{$t('btn_more')}}</div>
					</div>
				</div>
			</div>
		</div>

		<section class="model1">
			<div class="wrapper">
				<h2>
					<p class="til">{{$t('model1.title')}}</p>
					<span class="desc">{{$t('model1.desc')}}</span>
				</h2>
				
				<ul>
					<li>
						<img src="@/assets/images/icon01.png">
						<h3>{{$t('model1.li01.title')}}</h3>
						<p>{{$t('model1.li01.desc')}}</p>
					</li>
					<li>
						<img src="@/assets/images/icon02.png">
						<h3>{{$t('model1.li02.title')}}</h3>
						<p>{{$t('model1.li02.desc')}}</p>
					</li>
					<li>
						<img src="@/assets/images/icon03.png">
						<h3>{{$t('model1.li03.title')}}</h3>
						<p>{{$t('model1.li03.desc')}}</p>
					</li>
					
				</ul>
			</div>
			
		</section>
		<section class="model2">
			<h2>
				<p class="til">{{$t('model2.title')}}</p>
				<span class="desc">{{$t('model2.desc')}}</span>
			</h2>
			<div class="wrapper">
				<ul class="con">
					<li>
						<p class="til">{{$t('model2.li01.title')}}</p>
						<p>{{$t('model2.li01.desc')}}</p>
					</li>
					<li>
						<p class="til">{{$t('model2.li02.title')}}</p>
						<p>{{$t('model2.li02.desc')}}</p>
					</li>
					<li>
						<p class="til">{{$t('model2.li03.title')}}</p>
						<p>{{$t('model2.li03.desc')}}</p>
					</li>
					<li>
						<p class="til">{{$t('model2.li04.title')}}</p>
						<p>{{$t('model2.li04.desc')}}</p>
					</li>
				</ul>
				<div class="btn" @click="btnClick('service')">{{$t('model2.more')}}</div>
			</div>
			
		</section>
		<section class="model3">
			<h2>
				<p class="til">{{$t('model3.title')}}</p>
				<span class="desc">{{$t('model3.desc')}}</span>
			</h2>
			<div class="wrapper">
				<ul class="con">
					<li>
						<img src="@/assets/images/icon04.png">
						<p class="til">{{$t('model3.li01.title')}}</p>
						<p>{{$t('model3.li01.desc')}}</p>
					</li>
					<li>
						<img src="@/assets/images/icon05.png">
						<p class="til">{{$t('model3.li02.title')}}</p>
						<p>{{$t('model3.li02.desc')}}</p>
					</li>
					<li>
						<img src="@/assets/images/icon06.png">
						<p class="til">{{$t('model3.li03.title')}}</p>
						<p>{{$t('model3.li03.desc')}}</p>
					</li>
					<li>
						<img src="@/assets/images/icon07.png">
						<p class="til">{{$t('model3.li04.title')}}</p>
						<p>{{$t('model3.li04.desc')}}</p>
					</li>
				</ul>
			</div>
			
		</section>

		<!--Guide-->
		<section class="guide-box">
			<ul class="wrapper">
				<li>					
					<p class="til">{{$t('guide_home.li01.title')}}</p>
					<p>{{$t('guide_home.li01.desc')}}</p>
				</li>
				<li>
					<p class="til">{{$t('guide_home.li02.title')}}</p>
					<p>{{$t('guide_home.li02.desc')}}</p>
				</li>
				<li>
					<p class="til">{{$t('guide_home.li03.title')}}</p>
					<p>{{$t('guide_home.li03.desc')}}</p>
				</li>
				<li>
					<p class="til">{{$t('guide_home.li04.title')}}</p>
					<p>{{$t('guide_home.li04.desc')}}</p>
				</li>
			</ul>
			<div class="button-area">
				<div class="btn" @click="btnClick('join')">{{$t('btn_trade')}}</div>
				<div class="btn sec" @click="btnClick('about')">{{$t('btn_more')}}</div>
			</div>
			
		</section>
		
		<Footer />
	</div>
</template>

<script>
	import '@/assets/css/base.css';
	import '@/utils/rem.js';
	import { useRoute,useRouter } from 'vue-router';
	import { defineComponent, reactive, computed, ref, toRefs, onMounted } from "vue";
	import { useStore } from "vuex";
	import config from "@/utils/config";
	import Header from "@/components/Header.vue";
	import Footer from "@/components/Footer.vue";
	import $api from "@/utils/api";
	import { supportedLanguages } from '@/utils/config';
	import {sysPlatform} from "@/utils/util";
	import { useI18n } from 'vue-i18n';
	import {languageInit} from "@/utils/util";
	import i18n from '@/plugins/i18n';

	export default {
	name: 'Home',
	components:{
		Header,
		Footer
	},
	setup(){
		const $i18n = useI18n();
		const {t} = useI18n();
		const $store = useStore();
		const $router = useRouter();
		const $route = useRoute();
		const state = reactive({
			language:'en_US',
			langObj:{}
		});

		const download = ref(null);
		const scrollTo = ()=>{
			window.scrollTo({
				// y方向坐标800px（代码中不需要写明单位）
				top: download.value.getBoundingClientRect().top,
				// 滚动方式是平滑滚动 默认是auto 即instant 直接跳到目标位置  不常用
				behavior: "smooth",
			});
		}
		
		const languageInita = async ()=>{
			const localLang = localStorage.getItem("language");
			if($route.query.lang!=undefined&&$route.query.lang!='') {
                if($route.query.lang.indexOf('zh')>-1){
                    state.language = "zh_CN";
                }else{
                    state.language = "en_US";
                }
				state.language = $route.query.lang;				
			}else if(localLang){
				state.language = localLang;	
			}

			localStorage.setItem("language",state.language);
            $i18n.locale.value = await languageInit(state.language);
            state.language = $i18n.locale.value;
		}

		const btnClick=(type)=>{
			if(type=="cs"){
				
			}else if(type=="contact"){
				//window.location.href = `mailto:support@example.com?subject=''`;			
			}else if(type=="service"){
				$router.push('service')
			
			}else if(type=="about"){
				$router.push('about')
			}else if(type=="join"){
				$router.push('about')
			}
		}

		onMounted(() => {
            window.document.title = t('appName');
			state.platform = sysPlatform();
        });
	

		languageInita();

		return {
			...toRefs(state),
			scrollTo,
			btnClick
		}
	}

}
</script>
<style lang="scss" scoped>
	@import url('@/assets/css/home.css');
	
</style>